<template>
	<el-dialog title="选择省份" :visible.sync="visible" width="30%" :before-close="befclose" :close-on-click-modal="false">
		<div>
			<el-checkbox-group v-model="checkedList" size="medium">
				<el-row :gutter="20">
					<el-checkbox v-for="city in provinceList" v-show="city.provinceName != '国外'" :label="city.provinceCode" :key="city.provinceCode" :value="city" :disabled="city.disabled" border size="medium">{{city.provinceName | subFilter}}</el-checkbox>
				</el-row>
			</el-checkbox-group>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button @click="handleCancel">取 消</el-button>
			<el-button type="primary" @click="handleConfirm">确 定</el-button>
		</span>
	</el-dialog>
</template>
<script>
import {crmApi}  from "@/services";
// const R = require("ramda")
export default {
	props: {
		visible: {
			type: Boolean,
			required: true
		},
		provinceList: {
			type: Array,
			required: true
		},
		selectProvice:{
			type: Array,
			default() {
				return []
			}
		},
		disabledProvice:{
			type: Array,
			default() {
				return []
			}
		}
	},
	watch:{
		provinceList:{
			immediate:true,
			handler(val){
				console.log(1111,val)
			}
		}
	},
	data() {
		return {
			checkedList: []
		};
	},
	computed: {
		// 过滤出城市中已远中的城市数据
		selects() {
			return this.provinceList.filter((city) =>{
				return this.checkedList.includes(city.provinceCode)
			})
		},
		allData() {
			const { provinceList, disabledProvice } = this
			return {
				provinceList,
				disabledProvice
			}
		}
	},
	watch:{
		selectProvice:{
			handler: function(newValue, oldValue) {
				const checkedProvices = newValue.map((item) => {
					return item.provinceCode
				})
				this.checkedList = checkedProvices;
			},
			immediate: true,
			deep: true
		},
		visible() {
			let flag = this.visible;
			let selectProvice = this.selectProvice;
			if (flag) {
				if (selectProvice.length === 0) {
					this.checkedList.splice(0, this.checkedList.length);
				}
			}
		},
		allData(newValue, oldValue){
			if( !R.isEmpty(newValue.provinceList) && !R.isEmpty(newValue.disabledProvice)){
				newValue.provinceList.forEach(element => {
					if(newValue.disabledProvice.includes(element.provinceCode)){
						element.disabled = true;
					}else{
						element.disabled = false;
					}
				});
				console.log("计算过的新省份",newValue.provinceList);
			}
		}
	},
	methods: {
		handleCancel() {
			this.checkedList = this.selectProvice.map((item) => {
				return item.provinceCode
			})
			this.$emit("cancel")
		},
		handleConfirm() {
			this.$emit("confirm", JSON.parse(JSON.stringify(this.selects)));
		},
		befclose(){
			this.checkedList = this.selectProvice.map((item) => {
				return item.provinceCode
			})
			this.$emit("handelCityClose");
		},
	}
};
</script>
<style lang="scss" scoped>
.el-dialog__wrapper {
	/deep/.el-dialog__header{
		padding: 10px 40px 0px 20px
	}
	/deep/.el-dialog__body {
		padding: 10px 20px;
		.el-checkbox-group{
			.el-col-6{
				margin-top: 10px;
				.grid-content{
					background-color: #f5f6fb ;
					height: 40px;
					color: #323232
				}
			}
			.el-checkbox{
				background-color: #f5f6fb ;
				height: 40px;
				color: #323232;
				width: calc( 25% - 4px - 4px );
				text-align: center;
				margin: 0;
				margin-top: 8px;
				margin-left: 4px;
				margin-right: 4px;
				padding: 7px 10px 7px 10px;
				.el-checkbox__label{
					padding: 0;
				}
				.el-checkbox__inner{
					display: none;
				}
			}
			.is-checked{
				background-image: url(../../asserts/img/btn_xuanzhong.png);
				background-repeat: no-repeat;
				background-position: top right
			}
		}
		.el-col-6{
			margin-top: 10px;
			.grid-content{
				background-color: #f5f6fb ;
				height: 40px;
				color: #323232
			}
		}
	}
}
</style>
